export default __webpack_public_path__ + "ca77c22b3b1ea72b9b48799a55512922.svg";